import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import type { BookingPriceView } from '@/components/booking/price-preview'

interface BookingPricePreviewActions {
  clearPricePreview: () => void
  setPricePreview: (sessionId: string, preview: BookingPriceView) => void
}

interface BookingPricePreviewState {
  sessionId: null | string
  preview: BookingPriceView | null
}

/**
 * Aperçu du tarif de l'offre cliquée, déposé au moment de la sélection du vol et lu par
 * la sidebar de /informations le temps que le price Affidium réponde (plusieurs secondes).
 *
 * Strictement décoratif : aucun chemin de soumission ni aucune validation ne le lit, et
 * il est effacé dès que le price confirmé arrive. Stocké en `sessionStorage` : l'aperçu
 * doit survivre à un rafraîchissement de la page, pas passer d'un onglet à l'autre.
 */
export const useBookingPricePreviewStore = create<
  BookingPricePreviewActions & BookingPricePreviewState
>()(
  persist(
    (set) => ({
      sessionId: null,
      clearPricePreview: () => {
        set({ sessionId: null, preview: null })
      },
      preview: null,
      setPricePreview: (sessionId, preview) => {
        set({ sessionId, preview })
      },
    }),
    {
      name: 'booking-price-preview',
      partialize: (state) => ({ sessionId: state.sessionId, preview: state.preview }),
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)

/** Aperçu de CETTE session uniquement : un aperçu orphelin n'est jamais affiché. */
export function usePricePreviewForSession(sessionId: string | undefined): BookingPriceView | null {
  return useBookingPricePreviewStore((state) =>
    sessionId && state.sessionId === sessionId ? state.preview : null
  )
}
